import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ru from "./locales/ru.json";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import hy from "./locales/hy.json";
import tr from "./locales/tr.json";
import ProviderUtils from "../utils/provider.utils";
import { DEFAULT_LANGUAGE, LANGUAGES, resolveLanguage } from "./language";

export type AppLanguage = (typeof LANGUAGES)[number];

const getStoredUserRoles = (): string[] => {
  try {
    const storedUser = localStorage.getItem("user");

    if (!storedUser) {
      return [];
    }

    const parsedUser = JSON.parse(storedUser);

    return Array.isArray(parsedUser?.privileges) ? parsedUser.privileges : [];
  } catch (error) {
    console.error("Failed to parse stored user for language detection", error);
    return [];
  }
};

const initialLanguage = resolveLanguage({
  provider: ProviderUtils.getProvider(),
  roles: getStoredUserRoles(),
  preferredLanguage: localStorage.getItem("language"),
  fallbackLanguage: navigator.language,
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: LANGUAGES,
    resources: {
      ru: { translation: ru },
      en: { translation: en },
      ar: { translation: ar },
      hy: { translation: hy },
      tr: { translation: tr },
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "language",
    },
  });

export default i18n;
